import { ReactElement } from 'react'
import { RenderType, SectionTemplate } from '../types'
import HeroSection from './HeroSection'
import NarrativeSection from './NarrativeSection'
import ComparisonSection from './ComparisonSection'
import DeepDiveSection from './DeepDiveSection'
import ChartCompareSection from './ChartCompareSection'
import ChartTrajectorySection from './ChartTrajectorySection'
import TagGridSection from './TagGridSection'
import ActionCardsSection from './ActionCardsSection'
import DecisionSection from './DecisionSection'

export interface SectionRendererProps {
  template: SectionTemplate
  values: Record<string, unknown>
  /** Resolved heading + sub-description (override or template default). Each renderer should
   * use these instead of reading template.name / template.description directly. */
  title: string
  description: string
  sectionNumber?: number
  clientName: string
  currentRole: string
  publishedAt?: string
  disclaimer?: string
}

type Renderer = (props: SectionRendererProps) => ReactElement | null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SECTION_RENDERERS: Record<RenderType, Renderer> = {
  hero: (p) => (
    <HeroSection
      template={p.template}
      values={p.values as { tagline?: string }}
      clientName={p.clientName}
      currentRole={p.currentRole}
      publishedAt={p.publishedAt}
    />
  ),
  narrative: (p) => (
    <NarrativeSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  comparison: (p) => (
    <ComparisonSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  deepDive: (p) => (
    <DeepDiveSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  chartCompare: (p) => (
    <ChartCompareSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
      disclaimer={p.disclaimer}
    />
  ),
  chartTrajectory: (p) => (
    <ChartTrajectorySection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  tagGrid: (p) => (
    <TagGridSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  actionCards: (p) => (
    <ActionCardsSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
  decision: (p) => (
    <DecisionSection
      template={p.template}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      values={p.values as any}
      title={p.title}
      description={p.description}
      sectionNumber={p.sectionNumber}
    />
  ),
}
